import { render, staticRenderFns } from "./DistributorDetails.vue?vue&type=template&id=044a7a7a&scoped=true&"
import script from "./DistributorDetails.vue?vue&type=script&lang=js&"
export * from "./DistributorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044a7a7a",
  null
  
)

export default component.exports